module.exports = __webpack_public_path__ + "img/img_yichehui.0899e132.png";